import styled from "styled-components"
import { Link } from "gatsby"

export const Logo = styled.img`
  width: 3rem;
  margin: 0;
`

export const StyledLink = styled(Link)`
  display: flex;
  font-weight: 700;
  align-items: center;
`

export const Nav = styled.nav`
  display: flex;
  justify-content: flex-end;
  font-family: font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-weight: 700;
  font-size: 1.1rem;
  align-items: center;
  a {
    text-decoration: none;
    padding: 0.5rem 1rem;
    background-color: #222;
    border-radius: 20px;
    color: #fff;
    margin: 0 0.5rem;
    transition: all 0.4s cubic-bezier(0.645, 0.045, 0.355, 1);
    &:hover {
      color: #00c853;
    }
  }
`
